import React from 'react';
import PropTypes from 'prop-types';

import { Label } from 'components/core/Label';
import { CoreTextarea } from 'components/core/library/textarea';

export default function TextArea({
	errorMessage, helpText, input, label, meta
}) {
	return (
		<Label
			text={label}
			htmlFor={input.id || input.name}
			helpText={helpText}
			textAfterChildren={false}
			textClassName="textarea"
		>
			<CoreTextarea
				{...input}
				valid={meta.valid}
			/>
			{meta.touched && meta.error &&
				<div className="input-error">
					{errorMessage || meta.error}
				</div>
			}
		</Label>
	);
}

TextArea.propTypes = {
	errorMessage: PropTypes.string,
	helpText: PropTypes.string,
	input: PropTypes.object,
	label: PropTypes.string,
	meta: PropTypes.object,
};
